import { RibbonId } from './ribbonId';
export const getStringRibbonId = (id: RibbonId) => id.toString();
